var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 341,
    viewBox: "0 0 9 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e22",
    d: "M0 0h9v6H0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#094",
    d: "M0 3h9v3H0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd0",
    d: "M3.9 3.8 4.5 2l.6 1.8-1.54-1.1h1.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBf);
export default __webpack_public_path__ + "static/media/bf.482fd88ffa379629a61539745c216e76.svg";
export { ForwardRef as ReactComponent };